'use client';
import { useState } from 'react';
import styles from '../../page.module.scss';
import PrimaryButton from '../buttons/PrimaryButton';
import bgShape from '../../assets/decos/bg-shape-yellow.svg';

export default function DistribuidoraSection() {
  const [showTooltip, setShowTooltip] = useState(false);

  const copyEmailToClipboard = async () => {
    const email = 'lalibredistribuidora@gmail.com';

    try {
      await navigator.clipboard.writeText(email);
      setShowTooltip(true);

      // Ocultar el tooltip después de 2 segundos
      setTimeout(() => {
        setShowTooltip(false);
      }, 2000);
    } catch (err) {
      console.error('Error al copiar el email:', err);
      // Fallback para navegadores que no soportan clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = email;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false);
      }, 2000);
    }
  };

  return (
    <div>
      <section id="distribuidora" className={styles.distribuidoraContainer}>
        <div className={styles.distribuidoraHeader}>
          <h2 className={styles.title}>Distribución</h2>
        </div>
        <p className={styles.distribuidoraText1}>
          Somos editorial, librería y distribuidora. Apostamos a la autogestión y el trabajo
          colectivo en todo lo que hacemos.
        </p>
        <img
          className={styles.distribuidoraImage}
          src={'/assets/images/distribuidora.png'}
          alt="imagen de una carretilla"
        />
        <p className={styles.distribuidoraText2}>
          Distribuimos libros de las siguientes editoriales:
        </p>
        <div className={styles.list}>
          <ul className={styles.text}>
            <li>La Libre</li>
            <li>Segunda en Papel</li>
            <li>Ginecosofía</li>
            <li>Pez en el hielo</li>
            <li>Malisia </li>
            <li>Pixel </li>
            <li> Archivida</li>
          </ul>
          <ul className={styles.text}>
            <li>Indómita Luz</li>
            <li>IPA: Ideas Paliativas en Acción</li>
            <li>Detodoslosmares</li>
            <li>Filosurfer</li>
            <li>EME</li>
            <li>Club Hem </li>
          </ul>
        </div>
        <div className={styles.distribuidoraButton} style={{ position: 'relative' }}>
          <PrimaryButton
            primary={false}
            text="lalibredistribuidora@gmail.com"
            onClick={copyEmailToClipboard}
          />
          {showTooltip && <div className={styles.tooltip}>El mail ha sido copiado</div>}
        </div>
      </section>
      <img src={bgShape.src} alt="image de fondo decorativa" />
    </div>
  );
}
